import React from "react";
import { canWrite } from "../auth/perm";

const cell = "px-3 py-2 text-sm border-b border-gray-200";
const th =
  "px-3 py-2 text-xs font-bold text-gray-600 border-b border-gray-300 bg-gray-50";

const UsersTable = ({
  items = [],
  loading,
  onEdit,
  isRtl = true,
  currentUser,
  onSub,
  onNotif,
  onDelete,
}) => {
  const mayEdit = canWrite(currentUser, "users");
  const subscriptionDontShow = currentUser?.organization?.name;
  if (loading) {
    return <p className="text-sm text-gray-500">در حال بارگذاری...</p>;
  }
  if (!items.length) {
    return <p className="text-sm text-gray-500">نتیجه‌ای یافت نشد.</p>;
  }

  return (
    <div className="bg-white rounded-xl border border-gray-200 overflow-x-auto">
      <table className={`min-w-full ${isRtl ? "text-right" : "text-left"}`}>
        <thead>
          <tr>
            <th className={th}>نام</th>
            <th className={th}>موبایل</th>
            <th className={th}>ایمیل</th>
            <th className={th}>تگ‌ها</th>
            <th className={th}>عملیات</th>
          </tr>
        </thead>
        <tbody>
          {items.map((u) => (
            <tr key={u._id} className="hover:bg-gray-50">
              <td className={cell}>{u.name || "-"}</td>
              <td className={cell}>{u.phone || "-"}</td>
              <td className={cell}>{u.email || "-"}</td>
              <td className={cell}>
                {Array.isArray(u.tags) && u.tags.length
                  ? u.tags.join(", ")
                  : "-"}
              </td>
              <td className={cell}>
                <button
                  onClick={() => onEdit(u)}
                  disabled={!mayEdit}
                  className={`px-3 py-1.5 text-sm rounded-md
        ${
          mayEdit
            ? "bg-purple-600 text-white hover:bg-purple-700"
            : "bg-gray-200 text-gray-400 cursor-not-allowed"
        }
      `}
                >
                  ادیت
                </button>
                {subscriptionDontShow ? (
                  ""
                ) : (
                  <button
                    onClick={() => onSub(u)}
                    disabled={!mayEdit}
                    className={`px-3 py-1.5 text-sm rounded-md mx-1
                    ${
                      mayEdit
                        ? "bg-indigo-600 text-white hover:bg-indigo-700"
                        : "bg-gray-200 text-gray-400 cursor-not-allowed"
                    }
                  `}
                  >
                    اشتراک
                  </button>
                )}
                <button
                  onClick={() => onNotif?.(u)}
                  disabled={!mayEdit}
                  className={`px-3 py-1.5 text-sm rounded-md mx-1
    ${
      mayEdit
        ? "bg-emerald-600 text-white hover:bg-emerald-700"
        : "bg-gray-200 text-gray-400 cursor-not-allowed"
    }
  `}
                >
                  نوتیف
                </button>

               <button
                  onClick={() => onDelete?.(u)}
                  disabled={!mayEdit}
                  className={`px-3 py-1.5 text-sm rounded-md mx-1 ${
                    mayEdit
                      ? "bg-red-600 text-white hover:bg-red-700"
                      : "bg-gray-200 text-gray-400 cursor-not-allowed"
                  }`}
                >
                  حذف کاربر
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default UsersTable;
